module.exports = __webpack_public_path__ + "img/lan_tour_route_02.d5edd93d.jpg";